module.exports = __webpack_public_path__ + "assets/img/zh9.308329f2.png";